import { getAllSavedPois } from '@/utils/actions';
import { useQuery } from '@tanstack/react-query';

export default function useGetAllSavedPoisQuery() {
  const { data: savedPois } = useQuery({
    queryKey: ['getAllSavedPois'],
    queryFn: async () => {
      return await getAllSavedPois();
    },
    staleTime: 1000 * 60 * 60,
  });
  return savedPois;
}
